"use client";

import { useI18n } from "@/locales/client";

interface InputErrorProps {
    errorMessage: string;
}

export function InputError(props: InputErrorProps) {
    const t = useI18n();
    return (
        <div className="pointer-events-none absolute top-[70%] z-10 ml-2 w-fit rounded-md border bg-background px-2 py-1 text-xs text-destructive shadow-md ">
            {
                //@ts-expect-error translations are typed and interpolating the error message typescript cannot understand the type
                t(`validationErrors.${props.errorMessage}`)
            }
        </div>
    );
}
